/**
 * Log outbound booking emails so reminders can use last-sent time.
 * @see supabase/migrations/20261010204843_create_offer_email_sends.sql
 */

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {{ applicationId: number, kind?: 'offer'|'reminder', channel: 'gmail'|'mailto', toEmail?: string }} row
 */
export async function recordOfferEmailSend(supabase, { applicationId, kind, channel, toEmail }) {
  if (!applicationId || !channel) {
    return { ok: false, reason: 'missing_application_or_channel' };
  }
  const { error } = await supabase.from('offer_email_sends').insert({
    application_id: applicationId,
    kind: kind === 'reminder' ? 'reminder' : 'offer',
    channel,
    to_email: toEmail ? String(toEmail).trim() : null,
  });
  if (error) {
    console.warn('recordOfferEmailSend failed', error);
    return { ok: false, reason: error.message };
  }
  return { ok: true };
}
